export default __webpack_public_path__ + "static/media/facebook.00de844f.svg";